import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import userIcon from "../../images/icon/user-balck-icon.svg";
import emailIcon from "../../images/icon/sms-balck-icon.svg";
import phoneIcon from "../../images/icon/call-icon02.svg";
import listIcon from "../../images/icon/list-icon.svg";

const engagementOptions = [
  "Full Time",
  "Part Time",
  "Hourly Basis",
  "Fixed Project",
];

const EstimateProjectForm: React.FC = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    phone: "",
    engagement: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({ className: "wdev-form-error" })
  );

  const changeHandler = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setForms({ ...forms, [name]: value });

    if (validator.allValid()) validator.hideMessages();
    else validator.showMessages();
  };

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (validator.allValid()) {
      console.log("Estimate form submitted:", forms);
      alert("Thank you! We will get back to you shortly.");

      setForms({
        name: "",
        email: "",
        phone: "",
        engagement: "",
        message: "",
      });
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  return (
    <div className="wdev-estimate-form">
      <div className="wdev-estimate-form__header">
        <h3>Estimate Project Cost &amp; Time</h3>
      </div>

      <form onSubmit={submitHandler} className="wdev-estimate-form__body">
        <div className="wdev-form-field">
          <label htmlFor="wdev-name" className="sr-only">Full Name</label>
          <div className="wdev-form-field__control">
            <input
              id="wdev-name"
              name="name"
              type="text"
              placeholder="Full Name"
              value={forms.name}
              onChange={changeHandler}
              autoComplete="name"
            />
            <img src={userIcon} alt="" className="wdev-form-field__icon" />
          </div>
          {validator.message("name", forms.name, "required|alpha_space")}
        </div>

        <div className="wdev-form-field">
          <label htmlFor="wdev-email" className="sr-only">Email Address</label>
          <div className="wdev-form-field__control">
            <input
              id="wdev-email"
              name="email"
              type="email"
              placeholder="Email Address"
              value={forms.email}
              onChange={changeHandler}
              autoComplete="email"
            />
            <img src={emailIcon} alt="" className="wdev-form-field__icon" />
          </div>
          {validator.message("email", forms.email, "required|email")}
        </div>

        <div className="wdev-form-field">
          <label htmlFor="wdev-phone" className="sr-only">Contact Number</label>
          <div className="wdev-form-field__control">
            <input
              id="wdev-phone"
              name="phone"
              type="tel"
              placeholder="Contact Number"
              value={forms.phone}
              onChange={changeHandler}
              autoComplete="tel"
            />
            <img src={phoneIcon} alt="" className="wdev-form-field__icon" />
          </div>
          {validator.message("phone", forms.phone, "required")}
        </div>

        <div className="wdev-form-field">
          <label htmlFor="wdev-engagement" className="sr-only">Engagement Type</label>
          <div className="wdev-form-field__control">
            <select
              id="wdev-engagement"
              name="engagement"
              value={forms.engagement}
              onChange={changeHandler}
              required
            >
              <option value="">Select engagement type</option>
              {engagementOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
            <img src={listIcon} alt="" className="wdev-form-field__icon" />
          </div>
          {validator.message("engagement", forms.engagement, "required")}
        </div>

        <div className="wdev-form-field wdev-form-field--textarea">
          <label htmlFor="wdev-message" className="sr-only">Message</label>
          <textarea
            id="wdev-message"
            name="message"
            placeholder="Message"
            rows={4}
            value={forms.message}
            onChange={changeHandler}
          />
          {validator.message("message", forms.message, "required")}
        </div>

        <button type="submit" className="wdev-estimate-form__submit">
          Submit Request
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M3 8h10M9 4l4 4-4 4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </form>
    </div>
  );
};

export default EstimateProjectForm;
